module.exports = __webpack_public_path__ + "static/media/error-fareNotAvailable.e7991d6a.svg";